import { z } from 'zod'
import { optionalCnpjCpfSchema } from '@/shared'

export const academiaSchema = z.object({
  razaoSocial: z
    .string()
    .min(1, 'Nome da academia é obrigatório')
    .min(3, 'Nome da academia deve ter pelo menos 3 caracteres')
    .max(150, 'Nome da academia deve ter no máximo 150 caracteres'),
  cnpjCpf: optionalCnpjCpfSchema,
  email: z.string().min(1, 'E-mail é obrigatório').email('E-mail inválido'),
  telefone: z
    .string()
    .min(1, 'Telefone é obrigatório')
    .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, 'Telefone inválido'),
  cep: z
    .string()
    .refine((val) => !val || /^\d{5}-\d{3}$/.test(val), { message: 'CEP inválido' })
    .optional(),
  rua: z.string().max(200, 'Rua deve ter no máximo 200 caracteres').optional(),
  numero: z.string().max(20, 'Número deve ter no máximo 20 caracteres').optional(),
  complemento: z.string().max(100, 'Complemento deve ter no máximo 100 caracteres').optional(),
  bairro: z.string().max(100, 'Bairro deve ter no máximo 100 caracteres').optional(),
  cidade: z.string().max(100, 'Cidade deve ter no máximo 100 caracteres').optional(),
  estado: z
    .string()
    .refine((val) => !val || val.length === 2, { message: 'Estado deve ter 2 caracteres' })
    .optional(),
  descricao: z.string().max(500, 'Descrição deve ter no máximo 500 caracteres').optional(),
})

export type AcademiaFormData = z.infer<typeof academiaSchema>
